module.exports = __webpack_public_path__ + "assets/images/template/project/wuhan_zoomin-desktop.gif?v=c4ce0513";